import React, { useMemo } from 'react';
import ThreeSixtyImageView from './ThreeSixtyImageView';
import { useAppName } from '../../utils/sitecoreContext';
import { variant1 } from './service/constants';
const ThreeSixtyImageViewMap = ({ variant: propVariant, gtmVehicleData, ...props }) => {
    const appName = useAppName();
    let variant;
    switch (appName) {
        // ### VARIANT2 — can be pass through propVariant and used in BAP pages
        default:
            variant = variant1;
    }
    const appNameConfig = useMemo(() => ({ variant: propVariant !== null && propVariant !== void 0 ? propVariant : variant }), [propVariant, variant]);
    return React.createElement(ThreeSixtyImageView, { appNameConfig: appNameConfig, gtmVehicleData: gtmVehicleData, ...props });
};
export default ThreeSixtyImageViewMap;
